

























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MaintenanceByGameBody extends Vue {
  @Prop() readonly data!: object;
}
